<template>
    <el-table
        ref="mixTable"
        :data="datalist"
        @row-dblclick="innerRowDbClick"
        @row-click="innerRowClick"
        border
        @select="handleSelectionChange"
        @select-all="selectAll"
        @header-dragend="changeColWidth"
        :row-key="idField"
        default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        class="el-table--scrollable-y"
        empty-text="暂无数据"
        :indent="0"
        tooltip-effect="light"
        :span-method="loadSpanMethod"
        :treeCol="treeCol"
        :autoSelect="autoSelect"
        :row-class-name="rowClass"
        @sort-change="sortChange"
        :cell-style="cellStyle"
        :header-cell-style="headerStyle"
        :cell-class-name="cellClass"
        @scrollToBottom="scrollToBottom"
    >
        <!--额外部分标题-->
        <el-table-column type="expand" v-if="expandColumn && expandColumn[0] && expandColumn[0].length > 0">
            <template slot-scope="scope">
                <el-row v-for="(g, index) in expandColumn" :key="index">
                    <el-col :span="12" v-for="(item, index) in g" :key="index">
                        <el-row>
                            <el-col :span="8" class="padding20 padding-none-v">
                                <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.label.content || item.label }}:</div>
                            </el-col>
                            <el-col :span="16">
                                <TextFormatter
                                    :class="item.type"
                                    v-if="filter_readonly(item, scope.row)"
                                    :type="item.type"
                                    v-model="scope.row[item.prop]"
                                    :options="filter_option(item, scope.row)"
                                    @extrabutton-click="ExtraButtonClick($event, { index: scope.$index, row: scope.row })"
                                ></TextFormatter>
                                <item-input
                                    v-else
                                    :type="item.type"
                                    v-model="scope.row[item.prop]"
                                    :options="filter_option(item, scope.row)"
                                    v-bind="item.config"
                                    @input="ItemChange({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                                    @change="ItemOnBlurChange(arguments, { index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                                    @extrabutton-click="ExtraButtonClick($event, { index: scope.$index, row: scope.row, prop: item.prop })"
                                ></item-input>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </template>
        </el-table-column>
        <!--checkbox全选及序号-->
        <el-table-column v-if="selection" type="selection" width="30" align="center" header-align="center" :selectable="selectable"></el-table-column>
        <el-table-column v-if="showSequence" type="index" label="序号" :fixed="fixedLeftColumn.length > 0" width="40" align="center" header-align="center"> </el-table-column>
        <!--正常展示标题-->
        <el-table-column
            v-for="(item, index) in listColumn"
            :key="`${item.prop}${index}`"
            :prop="item.prop"
            :width="item.width"
            :label="item.label"
            :filters="item.filters && transfer(item.options)"
            :filter-method="item.filters && filterHandler"
            :show-overflow-tooltip="showTooltip(item)"
            :fixed="item.fixed"
            :sortable="item.sortable ? true : false"
            :sort-method="(a, b) => sortHandle(a, b, item.prop, item)"
            :align="treeStyle && index == 0 ? 'left' : 'center'"
            header-align="center"
        >
            <template slot="header" v-if="item.type == 'checkbox'">
                <el-checkbox size="mini" v-model="checkboxs[index]" @change="checkedChange(item, index)"></el-checkbox>
            </template>
            <div v-if="item.type == 'custom'" slot-scope="scope">
                <slot name="column" :index="scope.$index" :row="scope.row" :column="item"></slot>
                <slot :name="item.prop" :index="scope.$index" :row="scope.row" :column="item"></slot>
            </div>
            <div v-else @click="active_item = [scope.$index, index]" slot-scope="scope" :key="item.prop" :style="columnStyle(index, scope)">
                <TextFormatter
                    :col="item"
                    :row="scope.row"
                    :class="item.type"
                    v-if="!CanEdit(item, scope.row)"
                    :type="item.type"
                    v-model="scope.row[item.prop]"
                    v-bind="item.config"
                    :options="filter_option(item, scope.row)"
                    :colIndex="index"
                    @extrabutton-click="ExtraButtonClick($event, { index: scope.$index, row: scope.row })"
                >
                </TextFormatter>
                <item-input
                    :autofocus="active_item[0] == scope.$index && active_item[1] == index"
                    v-else
                    :type="item.type"
                    v-model="scope.row[item.prop]"
                    :options="filter_option(item, scope.row)"
                    @input="ItemChange({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                    v-bind="item.config"
                    @activeRow="setActiveRow(arguments)"
                    @extrabutton-click="ExtraButtonClick($event, { index: scope.$index, row: scope.row, prop: item.prop })"
                    @blur="ItemOnBlur({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                    @change="ItemOnBlurChange(arguments, { index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                    :clearable="(!item.config || item.config.clearable == undefined) && clearable"
                    :selectColumn="item.selectColumn"
                >
                </item-input>
            </div>
        </el-table-column>
    </el-table>
</template>

<script>

import TextFormatter from '../common/TextFormatter'
export default {
    name: `TreeTable`,
    components: { TextFormatter },
    props: {
        columns: { type: Array },
        selection: { type: Boolean },
        showSequence: { type: Boolean, default: true },
        tableHeight: { type: Number },
        clearable: { type: Boolean, default: true },
        spanMethod: { type: Function },
        treeStyle: { type: Boolean, default: false },
        datalist: { type: Array },
        idField: { type: String, default: `id` },
        parentField: { type: String, default: `parent_id` },
        treeCol: { type: String, default: `项目名称` },
        autoSelect: { type: Boolean, default: true },
        needEdit: { type: Boolean, default: false },
        genId: { type: Function },
        headerStyle: { type: Object },
        rowDbClick: { type: Function },
        rowClick: { type: Function }
    },
    data() {
        return {
            isAllSelect: false,
            clickRows: new Map(),
            active_item: [], // [行索引，列索引]
            isCtrl: false,
            previous: 0,
            preData: null
        }
    },
    created() {
        this.$nextTick(() => {
            this.setTableheight(0)
        })
    },
    mounted() {
        var isWin = navigator.platform == `Win32` || navigator.platform == `Windows`
        var isMac = navigator.platform == `Mac68K` || navigator.platform == `MacPPC` || navigator.platform == `Macintosh` || navigator.platform == `MacIntel`
        document.addEventListener(`keydown`, e => {
            if ((e.keyCode === 17 && isWin) || (e.keyCode === 91 && isMac)) {
                this.isCtrl = true
            }
        })
        document.addEventListener(`keyup`, e => {
            if ((e.keyCode === 17 && isWin) || (e.keyCode === 91 && isMac)) {
                this.isCtrl = false
            }
        })
    },
    computed: {
        _tableHeight() {
            return this.tableHeight
        },
        listColumn() {
            let r = _.filter(this.columns, x => !_.has(x, `isListable`) || x.isListable == true)
            return r
        },
        hasFixed() {
            return _.some(this.columns, lc => {
                return lc.fixed !== undefined
            })
        },
        fixedLeftColumn() {
            return _.filter(this.listColumn, lc => {
                return lc.fixed == `left`
            })
        },
        expandColumn() {
            let expandColumns = _.filter(this.columns, { isExpand: true })
            let newExpandColumns = expandColumns.map(function(value, index, array) {
                return Object.assign({}, value, { num: index / 2 })
            })
            return _.groupBy(newExpandColumns, function(c) {
                return Math.floor(c.num)
            })
        },
        pre_column_len() {
            // return this.selection ? 1 : 0 + this.showSequence ? 1 : 0 + (this.expandColumn && this.expandColumn[0] && this.expandColumn[0].length > 0 ? 1 : 0)
            return this.selection ? 1 : 0 + this.showSequence ? 1 : 0
        }
    },
    methods: {
        toTree(tmpList) {
            this.preData = null
            if (_.isEmpty(tmpList)) {
                return []
            }
            let arr = []
            for (let data of tmpList) {
                if (!_.has(data, this.idField)) {
                    this.$set(data, this.idField, this.generateId())
                }
                if (data[this.parentField] == 0) {
                    data[this.parentField] = null
                }
                if (!data[this.parentField]) {
                    arr.push(data)
                } else {
                    let parent = _.find(tmpList, x => x[this.idField] == data[this.parentField])
                    if (parent) {
                        if (!_.has(parent, `children`)) {
                            this.$set(parent, `children`, [])
                        }
                        parent.children.push(data)
                    } else {
                        arr.push(data)
                    }
                }
            }
            return this.init(arr)
        },
        selectable(row, index) {
            return !(row.disabled == true)
        },
        newRow(rowStatus) {
            let obj = {
                rowStatus: rowStatus,
                isRoot: true,
                checked: false,
                children: []
            }
            obj[this.idField] = this.generateId()
            return obj
        },
        getRow(id) {
            return _.find(this.datalist, x => x[this.idField] == id)
        },
        innerRowDbClick(row, column, event) {
            if (this.needEdit && this.rowDbClick) {
                if (!column || column.label == `操作` || column.type == `selection` || row.rowStatus > 0) {
                    return
                }
                if (event.offsetX < 20 && column.label == this.treeCol) {
                    return
                }
                let clickResult = this.rowDbClick(row, column, event)
                if (clickResult == true) {
                    row.rowStatus = 2
                }
            }
        },
        innerRowClick(row, column, event) {
            console.log(event)
            if (this.rowClick) {
                if (row[this.idField] && row.rowStatus == 0) {
                    if (this.preData == null) {
                        this.preData = _.cloneDeep(row)
                        // console.log(`null-->` + this.preData[this.idField])
                    } else {
                        // console.log(`not null-->` + this.preData[this.idField])
                        let newData = this.getById(this.preData[this.idField])
                        if (newData) {
                            this.preData.isRoot = newData.isRoot
                            this.preData.rowStatus = newData.rowStatus
                            this.preData.children = newData.children
                            this.preData.checked = newData.checked
                            this.preData.disabled = newData.disabled
                            if (this.isEqual(this.preData, newData)) {
                                newData.rowStatus = 0
                            }
                        }
                        this.preData = _.cloneDeep(row)
                    }
                }
                this.rowClick(row, column, event)
            }
        },
        cellClass({ row, column, columnIndex }) {
            let cls = column.property
            if (columnIndex >= this.pre_column_len) {
                if (this.listColumn[columnIndex - this.pre_column_len]) {
                    if (`select,groupselect,multiselect,groupmultiselect,remoteselect,remotemultiselect,remoteselecttable,`.indexOf(`${this.listColumn[columnIndex - this.pre_column_len].type},`) > -1) {
                        cls += ` cus-select`
                    }
                    if (row.cell_class && row.cell_class[column.property]) {
                        cls += ` ${row.cell_class[column.property]}`
                    }
                }
            }
            return cls
        },
        columnStyle(colIndex, scope) {
            if (this.treeStyle && colIndex == 0) {
                if (scope.row.isRoot) {
                    if (scope.row.readonly == true) {
                        return `min-height: 20px; width: 110px;padding-left:15px;`
                    } else {
                        return `min-height: 20px; width: 100%;padding-left:15px`
                    }
                } else {
                    return `min-height: 20px; width: 100%;padding-left:28px`
                }
            } else {
                return `min-height: 20px; width: 100%;`
            }
        },
        setActiveRow(args) {
            let _this = this

            let rowIndex = args[0]
            let cellIndex = args[1]
            let direction = args[2]

            var arr = []
            this.datalist.forEach(x => {
                arr.push(x)
                if (x.children && x.children.length > 0) {
                    x.children.forEach(y => {
                        arr.push(y)
                    })
                }
            })

            let row = arr[rowIndex]
            while (row && (row.disabled == true || row.enum_charge_status != 0)) {
                rowIndex = direction == `down` ? rowIndex + 1 : rowIndex - 1
                row = arr[rowIndex]
            }

            this.innerRowClick(row, null, null)
            row.rowStatus = 2
            _this.$nextTick(() => {
                let activeRow = this.$refs[`mixTable`].$el.querySelector(`.el-table__body-wrapper`).querySelectorAll(`.el-table__row`)[rowIndex]
                if (activeRow && activeRow.children[cellIndex]) {
                    let activeInput = activeRow.children[cellIndex].getElementsByTagName(`input`)[0]
                    activeInput && activeInput.focus()
                    activeInput && activeInput.select()
                }
            })
        },
        ExtraButtonClick({ emit }, { index, row }) {
            this.$emit(`extrabutton-click`, { emit, index, row: row })
        },
        init(tmpList) {
            if (_.isEmpty(tmpList)) { return [] }
            tmpList.map(i => {
                if (!_.has(i, `rowStatus`)) {
                    this.$set(i, `rowStatus`, 0)
                }
                this.$set(i, `isRoot`, !i[this.parentField])
                if (!_.has(i, `children`)) {
                    this.$set(i, `children`, [])
                }
                if (!_.has(i, `checked`)) {
                    this.$set(i, `checked`, false)
                }
                if (!_.has(i, `disabled`)) {
                    this.$set(i, `disabled`, false)
                }
                if (i.checked) {
                    this.selectOne(i)
                }
                if (i.children.length > 0) {
                    i.children.map(x => {
                        this.$set(x, `rowStatus`, 0)
                        this.$set(x, `isRoot`, false)
                        this.$set(x, this.parentField, i[this.idField])
                        if (!_.has(i, `disabled`)) {
                            this.$set(i, `disabled`, false)
                        }
                        if (!_.has(x, `checked`)) {
                            this.$set(x, `checked`, false)
                        }
                        if (x.checked) {
                            this.selectOne(x)
                        }
                        return x
                    })
                }
            })
            return tmpList
        },
        generateId() {
            if (this.genId && _.isFunction(this.genId)) {
                let id = this.genId()
                console.log(`genid:` + id)
                return id
            } else {
                return -_.now() - (++this.previous)
            }
        },
        uniqueNumber() {
            var date = Date.now()
            if (date <= this.previous) {
                date = ++this.previous
            } else {
                this.previous = date
            }
            return date
        },
        rowClass({ row, rowIndex }) {
            var cls = []
            if (row.isRoot && !row.html) {
                if (!row.html) {
                    cls.push(`rootClass`)
                } else {
                    cls.push(`bgWhite`)
                }
            }
            if (row.class_name) {
                cls.push(row.class_name)
            }
            return cls.join(` `)
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (row.html && row.readonly == true) {
                if (column.type == `selection`) {
                    return {
                        "text-indent": `-9999px`,
                        "border": `0px`,
                        "background-color": `white`
                    }
                } else {
                    return {
                        "border": `0px`,
                        "background-color": `white`
                    }
                }
            }
        },
        // rowStyle({ row, rowIndex }) {
        //     console.log(`rowStyle`)
        //     let obj = {}
        //     if (row.color) {
        //         obj.color = row.color
        //     }
        //     if (row[`background-color`]) {
        //         obj[`background-color`] = row[`background-color`]
        //     } else {
        //         if (row.isRoot) {
        //             obj[`background-color`] = `#cdeae8`
        //             // obj[`background-color`] = `#fff`
        //         }
        //     }
        //     console.log(obj)
        //     obj[`font-size`] = `50px`
        //     return obj
        // },
        setTableheight(interval) {
            let el = this.$refs[`mixTable`] && this.$refs[`mixTable`].$el.querySelector(`.el-table__body-wrapper`)
            let elFixed = this.$refs[`mixTable`] && this.$refs[`mixTable`].$el.querySelector(`.el-table__fixed-body-wrapper`)
            let elHeader = this.$refs[`mixTable`] && this.$refs[`mixTable`].$el.querySelector(`.el-table__header-wrapper`)
            el && el.style && (el.style.height = `${this.tableHeight - elHeader.offsetHeight - 5}px`)
            if (elFixed && elFixed.style) {
                elFixed.style.height = `${this.tableHeight - elHeader.offsetHeight - 5}px`
            } else if (this.hasFixed && interval < 1000) {
                setTimeout(() => {
                    this.setTableheight(interval + 100)
                }, interval)
            }
        },
        transfer(data) {
            return _.map(data, d => {
                return {
                    value: d.value,
                    text: d.label
                }
            })
        },
        showTooltip(item) {
            if (item.tooltip == true) {
                return true
            }
            if (item.tooltip == false) {
                return false
            }
            return item.readonly == true || item.readonly == undefined
        },
        filterHandler(value, row, column) {
            const property = column[`property`]
            return row[property] === value
        },
        ItemChange({ index, row, prop, column }) {
            if (column.change) {
                column.change(this, { index, row, prop, column })
            }
            this.$emit(`change`, { index, row, prop, area: `list` })
        },
        ItemOnBlur({ index, row, prop, column }) {
            if (column.blur) {
                column.blur(this, { index, row, prop })
            }
            this.$emit(`blur`, { index, row, prop, area: `list` })
        },
        ItemOnBlurChange(args, { index, row, prop, column }) {
            let changetext = args[0]
            let changeid = args[1]
            if (column.blurchange) {
                column.blurchange(this, { changetext, changeid, index, row, prop })
            }
            // this.$emit(`blurchange`, { changetext, changeid, index, row, prop, area: `list` })
        },
        filter_option(item, row) {
            if (item.options && _.isFunction(item.options)) {
                return item.options(this, { row: row, column: item, area: `list` })
            }
            return item.options
        },
        CanEdit(column, row) {
            if (row.readonly == true) {
                return false
            }
            if (column.type == `buttongroup`) {
                return true
            }
            if (row.rowStatus == 0 || !_.has(column, `readonly`)) {
                return false
            }
            if (_.isFunction(column.readonly)) {
                return !column.readonly(this, { row, column })
            }
            return !(column.readonly == undefined || column.readonly == true)
        },
        loadSpanMethod(obj) {
            return (this.spanMethod && this.spanMethod(obj)) || [1, 1]
        },
        addChild(curRow) {
            if (curRow && curRow[this.idField]) {
                let newRow = {
                    rowStatus: 1,
                    isRoot: false,
                    checked: false
                }
                this.$set(newRow, this.idField, this.generateId())
                this.$set(newRow, this.parentField, curRow[this.idField])
                curRow.children.push(newRow)
                return newRow
            } else {
                console.log(`没有当且节点Row参数`)
            }
        },
        addParent() {
            let newRow = this.newRow(1)
            this.datalist.push(newRow)
            return newRow
        },
        getLastRow() {
            return this.datalist[this.datalist.length - 1]
        },
        goUp(row, index) {
            if (index > 0) {
                let curorder = index + 1
                let prevorder = index
                // 交换当前行和上一行的数据
                const temp = this.datalist[index - 1]
                this.$set(this.datalist[index], `display_order`, prevorder) // 排序
                this.$set(this.datalist, index - 1, this.datalist[index])

                this.$set(temp, `display_order`, curorder)
                this.$set(this.datalist, index, temp)
            }
        },
        goDown(row, index) {
            if (index < this.datalist.length - 1) {
                // 交换当前行和下一行的数据
                let curorder = index + 1
                let nextorder = index + 2
                const temp = this.datalist[index + 1]
                this.$set(this.datalist[index], `display_order`, nextorder) // 排序
                this.$set(this.datalist, index + 1, this.datalist[index])
                this.$set(temp, `display_order`, curorder)
                this.$set(this.datalist, index, temp)
            }
        },
        deleteRow(row) {
            if (!row[this.idField]) return false
            if (row.isRoot == true || row[this.parentField] == null || row[this.parentField] == 0) {
                let curIndex = 0
                for (let data of this.datalist) {
                    if (data[this.idField] == row[this.idField]) {
                        this.datalist.splice(curIndex, 1)
                        let cur = this.datalist[curIndex]
                        if (cur && cur.readonly == true) {
                            this.datalist.splice(curIndex, 1)
                        }
                        return true
                    }
                    curIndex++
                }
                return false
            } else {
                var parent = _.find(this.datalist, x => x[this.idField] == row[this.parentField])
                if (parent) {
                    let curIndex = 0
                    for (let child of parent.children) {
                        if (child[this.idField] == row[this.idField]) {
                            parent.children.splice(curIndex, 1)
                            return true
                        }
                        curIndex++
                    }
                    return false
                } else {
                    let curIndex = 0
                    for (let data of this.datalist) {
                        if (data[this.idField] == row[this.idField]) {
                            this.datalist.splice(curIndex, 1)
                            return true
                        }
                        curIndex++
                    }
                    return false
                }
            }
        },

        cancelRow(row) {
            // 有bug
            // row.rowStatus = 0
            // console.log(`cancelRow：`)
            // console.log(row)
            // var removes = _.remove(this.editingRowsOrigin, x => x[this.idField] == row[this.idField])
            // console.log(removes)
            // if (removes && removes.length > 0) {
            //     Object.assign(row, removes[0])
            // }
        },
        selectAll(selection) {
            this.isAllSelect = !this.isAllSelect
            if (this.isAllSelect) {
                for (let row of this.datalist) {
                    this.selectOne(row, true)
                    row.children && row.children.forEach((ch) => {
                        this.selectOne(ch, true)
                    })
                }
            } else {
                for (let row of this.datalist) {
                    this.selectOne(row, false)
                    row.children && row.children.forEach((ch) => {
                        this.selectOne(ch, false)
                    })
                }
            }
            this.$emit(`selectAll`, this.isAllSelect)
            return false
        },
        changeColWidth(nw, ow, col, evt) {
            this.$emit(`changeColWidth`, nw, ow, col, evt)
        },
        scrollToBottom() {
            let scrollEl = this.$refs[`mixTable`].bodyWrapper
            scrollEl.scrollTo({ top: 50000, behavior: `smooth` })
        },
        selectOne(row, checked) {
            row.checked = checked
            this.$refs.mixTable.toggleRowSelection(row, checked)
        },
        handleSelectionChange(selection, row) {
            if (this.autoSelect == true) {
                row.checked = !row.checked
                if (row.isRoot) {
                    for (let ch of row.children) {
                        if (ch.checked != row.checked) {
                            this.selectOne(ch, row.checked)
                        }
                    }
                } else {
                    var parent = _.find(this.datalist, x => x[this.idField] == row[this.parentField])
                    if (!row.checked) {
                        if (parent.checked) {
                            this.selectOne(parent, false)
                        }
                    } else {
                        if (!parent.checked) {
                            var notchecks = _.find(parent.children, x => !x.checked)
                            if (!notchecks || notchecks.length == 0) {
                                this.selectOne(parent, true)
                            }
                        }
                    }
                }
            } else {
                row.checked = !row.checked
                this.$emit(`select`, row)
            }
        },
        getSelectedRows() {
            var arr = []
            for (let row of this.datalist) {
                if (row.checked) { arr.push(row) }
                if (row.children) {
                    row.children.forEach(x => {
                        if (x.checked) {
                            arr.push(x)
                        }
                    })
                }
            }
            return arr
        },
        getAllRows() {
            return _.filter(this.datalist, x => !x.readonly)
        },
        getAllData() {
            var arr = []
            this.datalist.forEach(x => {
                if (!x.readonly) {
                    arr.push(x)
                    if (x.children && x.children.length > 0) {
                        x.children.forEach(y => {
                            arr.push(y)
                        })
                    }
                }
            })
            return arr
        },
        getById(id) {
            for (let d of this.datalist) {
                if (d[this.idField] == id) {
                    return d
                }
                if (d.children) {
                    for (let ch of d.children) {
                        if (ch[this.idField] == id) {
                            return ch
                        }
                    }
                }
            }
            return undefined
        },
        isEqual(a, b) {
            return JSON.stringify(a) == JSON.stringify(b)
        },
        sortChange({ column, prop, order }) {
            let that = this
            this.order = order
            that.sortOrder(that.datalist, prop, order)
        },
        sortHandle(a, b, prop, column) {
            let res = 0
            // 有些列表最后面有一行空行，空行不参与排序
            if (!_.has(a, `id`) && !_.has(a, `___index`)) {
                return 0
            }

            if (!_.has(b, `id`) && !_.has(b, `___index`)) {
                return 0
            }
            // added by xiaorui,自定义排序函数，需要用到自定义排序的可以在对应列中编写sortChange 功能
            if (column.sortChange && _.isFunction(column.sortChange)) {
                res = column.sortChange(this, { a, b, prop, column })
            } else {
                let str1 = a[prop]
                if (!str1) return 1
                let str2 = b[prop]
                if (!str2) return -1
                if (this.isNumber(str1) && this.isNumber(str2)) {
                    return parseInt(str1) - parseInt(str2)
                }

                if (this.isLableValueObj(str1) && this.isLableValueObj(str2)) {
                    str1 = str1.label
                    str2 = str2.label
                }

                for (let i = 0; ; i++) {
                    if (!str1[i] || !str2[i]) {
                        res = str1.length - str2.length
                        break
                    }
                    const char1 = str1[i]
                    const char1Type = this.getChartType(char1)
                    const char2 = str2[i]
                    const char2Type = this.getChartType(char2)
                    // 类型相同的逐个比较字符
                    if (char1Type[0] === char2Type[0]) {
                        if (char1 === char2) {
                            continue
                        } else {
                            if (char1Type[0] === `zh`) {
                                res = char1.localeCompare(char2, `zh-CN`)
                            } else if (char1Type[0] === `en`) {
                                res = char1.charCodeAt(0) - char2.charCodeAt(0)
                            } else {
                                if (str1.length == str2.length) {
                                    res = char1 - char2
                                } else {
                                    res = str1.length - str2.length
                                }
                            }
                            break
                        }
                    } else {
                    // 类型不同的，直接用返回的数字相减
                        res = char1Type[1] - char2Type[1]
                        break
                    }
                }
            }

            return res
        },
        // added by xiaorui,点击排序后调用排序
        sortOrder(datalist, prop, order) {
            let that = this
            datalist.sort(function(c, d) {
                let res = 0
                let str1 = order == `descending` ? d[prop] : c[prop]
                let str2 = order == `descending` ? c[prop] : d[prop]
                if (!str1) return 1
                if (!str2) return -1

                if (that.isNumber(str1) && that.isNumber(str2)) {
                    return parseInt(str1) - parseInt(str2)
                }

                for (let i = 0; ; i++) {
                    if (!str1[i] || !str2[i]) {
                        res = str1.length - str2.length
                        break
                    }
                    const char1 = str1[i]
                    const char1Type = that.getChartType(char1)
                    const char2 = str2[i]
                    const char2Type = that.getChartType(char2)
                    // 类型相同的逐个比较字符
                    if (char1Type[0] === char2Type[0]) {
                        if (char1 === char2) {
                            continue
                        } else {
                            if (char1Type[0] === `zh`) {
                                res = char1.localeCompare(char2, `zh-CN`)
                            } else if (char1Type[0] === `en`) {
                                res = char1.charCodeAt(0) - char2.charCodeAt(0)
                            } else {
                                if (str1.length == str2.length) {
                                    res = char1 - char2
                                } else {
                                    res = str1.length - str2.length
                                }
                            }
                            break
                        }
                    } else {
                        // 类型不同的，直接用返回的数字相减
                        res = char1Type[1] - char2Type[1]
                        break
                    }
                }

                return res
            })
        },
        getChartType(char) {
            // 数字（0->9）->大写字母（A->Z）->小写字母（a->z）->中文拼音（a->z）
            if (/^[\u4e00-\u9fa5]$/.test(char)) {
                return [`zh`, 300]
            }
            if (/^[a-zA-Z]$/.test(char)) {
                return [`en`, 200]
            }
            if (/^[0-9]$/.test(char)) {
                return [`number`, 100]
            }
            return [`others`, 999]
        },
        isNumber(val) {
            var regPos = /^\d+(\.\d+)?$/
            var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
            if (regPos.test(val) || regNeg.test(val)) {
                return true
            } else {
                return false
            }
        },
        isLableValueObj(obj) {
            return typeof obj == `object` && _.has(obj, `value`) && _.has(obj, `label`)
        }
    },
    watch: {
        _tableHeight: function() {
            this.setTableheight(0)
        },
        hasFixed: function() {
            this.setTableheight(0)
        }
    }
}
</script>
<style  lang="less">
.el-table .caret-wrapper {
    height: 33px;
}

.sortable-tr-chosen td {
    // opacity:0.4 !important;
    background: var(--primary-lighter, rgba(0, 150, 136, 0.2)) !important; //rgba(0,150,136,0.2)
}
.cus-select .cell {
    overflow: visible !important;
}
.multiselect,
.groupmultiselect,
.remotemultiselect {
    .el-input--suffix .el-input__inner {
        padding-right: 5px !important;
    }
    .el-input__suffix {
        display: none !important;
    }
    .el-select__tags .el-select__input {
        margin-left: 5px;
    }
}
</style>
<style scoped lang="less">
.table-expand {
    font-size: 0;
}
.expand-label {
    color: #909399;
}
// .el-table /deep/ .cell {
//     text-align: center !important;
// }
/deep/ .el-table__placeholder {
    display: inline !important;
    width: 20px;
}
.el-table /deep/ .hover-row {
    background-color: var(--table-row-hover-bg, #cdeae8);
    // opacity: 0.1;
}
.el-table /deep/ .cell {
    position: relative;
}
.el-table /deep/ .el-table__expand-icon {
    position: absolute;
    left: -3px;
    bottom: 26%;
}
//border-collapse: collapse

.el-table /deep/ .el-table__header {
    border-collapse: collapse;
}
.el-table /deep/ .el-table__body {
    border-collapse: collapse;
}

// .el-table /deep/ td {
//     padding: 0px 2px !important;
//     border: 1px solid #d7d7d7;
//     color: #000000;
// }

.el-table /deep/ .rootClass {
    background: var(--table-row-hover-bg, #cdeae8);
    color: #000000;
}
.el-table /deep/ .rootClass input {
    color: #000000;
}
.el-table /deep/ th {
    background: var(--table-header-bg, #009688);
    color: var(--table-header-text, #fff);
    border: 1px solid #d7d7d7;
}

.el-table /deep/ .config-column {
    width: 150px;
    overflow: hidden;
    margin: 20px 0;
}
.el-table /deep/ .config-column .el-checkbox-group .el-checkbox {
    display: table-row;
}
.el-table .bgWhite/deep/ {
    background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/common/TreeTable.vue